import { render, staticRenderFns } from "./EdgeboardTasktypeConfigModal.vue?vue&type=template&id=60c4c476&"
import script from "./EdgeboardTasktypeConfigModal.vue?vue&type=script&lang=js&"
export * from "./EdgeboardTasktypeConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports